import layoutConstants from '../constants/layoutConstants';
import links from '../constants/linkConstants';
import { GamesAutocompleteSuggestionEntryType } from '../services/searchService';

const isAutocompleteSuggestion = suggestion => suggestion?.label === undefined;
const isKeywordSuggestion = suggestion =>
  isAutocompleteSuggestion(suggestion) &&
  suggestion.type === GamesAutocompleteSuggestionEntryType.QuerySuggestion;
const isGameSuggestion = suggestion =>
  isAutocompleteSuggestion(suggestion) &&
  suggestion.type === GamesAutocompleteSuggestionEntryType.GameSuggestion;

const getAutocompleteSearchType = suggestion => {
  switch (suggestion.type) {
    case GamesAutocompleteSuggestionEntryType.QuerySuggestion: {
      return 'keyword';
    }
    case GamesAutocompleteSuggestionEntryType.GameSuggestion: {
      return 'game';
    }
    default: {
      throw Error(`Unrecognized autocomplete suggestion, ${JSON.stringify(suggestion)}`);
    }
  }
};

const getDefaultSearchType = suggestion => {
  switch (suggestion.label) {
    case 'Label.Players': {
      return 'defaultPlayers';
    }
    case 'Label.AvatarShop':
    case 'Label.sCatalog': {
      return 'defaultShops';
    }
    case 'Label.sGroups': {
      return 'defaultGroups';
    }
    case 'Label.Library': {
      return 'defaultLibrary';
    }
    case 'Label.sGames': {
      return 'defaultGames';
    }
    default: {
      throw Error(`Unrecognized default suggestion, ${JSON.stringify(suggestion)}`);
    }
  }
};

const getSuggestionUrl = (suggestion, event) => {
  const { target } = event;
  if (isAutocompleteSuggestion(suggestion)) {
    return links.gameSearchLink.url + encodeURIComponent(suggestion.searchQuery);
  }
  if (target && target.value && target.value.length > layoutConstants.minimumSearchLength) {
    return suggestion.url + encodeURIComponent(target.value);
  }

  return '';
};

const serializeSuggestions = (suggestions, searchInput) =>
  suggestions
    .map(suggestion => {
      if (isAutocompleteSuggestion(suggestion)) {
        return `${getAutocompleteSearchType(suggestion)}|${suggestion.searchQuery}`;
      }
      return `${getDefaultSearchType(suggestion)}|${searchInput}`;
    })
    .join(',');

export default {
  isAutocompleteSuggestion,
  isGameSuggestion,
  isKeywordSuggestion,
  getAutocompleteSearchType,
  getDefaultSearchType,
  getSuggestionUrl,
  serializeSuggestions
};
